import React from 'react';
import { CirclePicker } from 'react-color';


class ColorPicker extends React.Component {
 constructor(props){
     super(props);
     this.handleChangeComplete=this.handleChangeComplete.bind(this);
    }
    state = {
      background: '#fff',
    };
    
  handleChangeComplete = (color) => {
    this.props.onColorChanged(color.hex);
    this.setState({ background: color.hex });
  };

  render() {
    return (
      <CirclePicker
        color={ this.props.props.designer.selectedShirtColor}
        onChangeComplete={ this.handleChangeComplete }
        colors={[...this.props.props.designer.availableColors]}
        width='100%'
      />
    );
  }
}

export default ColorPicker;